import React, { useEffect, useState, useRef } from 'react';
import styled from "styled-components";
import Cookies from 'js-cookie';

import MainNavigation from '../components/minskog/comps/MainNavigation/MainNavigation';
import Karta from '../components/minskog/Karta';
// import DroneAnalysis from '../components/minskog/comps/DroneAnalysis/DroneLandingPage';
import Overblick from '../components/minskog/Overblick';
import Woodprices from '../components/minskog/woodprices/Woodprices';
import ProfileAdListings from '../components/minskog/ProfileAdListings';
import UserSettings from '../components/minskog/comps/UserSettings';
import HSBoookAdvising from '../components/minskog/comps/HSBoookAdvising';
import { MarketInformation } from '../../min-skog-ts/pages/MarketInformation'
import { PlusBlockerDialogProvider } from '@components/PlusBlockerDialog/PlusBlockerDialog.context';
import SellTimber from '../components/minskog/comps/SellTimber';

import { usePropertyFetcher } from '../components/minskog/hooks/usePropertyFetcher';
import Aragon from '../components/minskog/Aragon';
import { DroneCheckoutWrapper } from '@components/Checkout/config/DroneCheckout/DroneCheckoutContext';
import { useOpenSubscriptionCheckout } from '@components/Checkout/config/SubscriptionCheckout/SubscriptionCheckoutContext';
import { useOpenDroneCheckout } from '@components/Checkout/config/DroneCheckout/DroneCheckoutContext';
import { DFRProvider } from "../components/minskog/context/DFRContext";
import { WoodpricesProvider } from '../components/minskog/woodprices/context/Woodprices';
import ArbonicsDialog from '../components/minskog/comps/ArbonicsDialog/ArbonicsDialog';
import UpdatePropsModal from '../components/minskog/comps/UpdatePropsModal';
import { useUpdatePropsModal } from '../components/minskog/hooks/useUpdatePropsModal';
import { useNavigationStore } from '../components/minskog/store/NavigationStore';
import { usePropsDataStore } from '../components/minskog/store/PropsDataStore';
import { useUserDataStore } from '../components/minskog/store/UserDataStore';
import { useDemoMinskogStore } from '../components/minskog/store/DemoMinskogStore';
import { KYCModal } from '../components/minskog/kyc/KYCModal';

import { fetchUserAdData, getKycPreferences } from '../api/services/user';
import { getProp, generateProp } from '../api/services/property';

import PricingPageNew from '../components/minskog/PricingPageNew';

import MinskogToolbar from '../components/minskog/comps/MinskogToolbar';
import NoActivePropsView from '../components/minskog/comps/NoActivePropsView';
import { Dialog, Text, Button, Icon, TwModal as Modal, Toaster } from "@ui-component-library";
import SectionDetails from '../components/minskog/comps/SectionDetails/SectionDetails';
import DemoBlockDialog from '../components/minskog/comps/DemoBlockDialog/DemoBlockDialog';

import { useLogin } from '../components/login/context/LoginContext';
import { useMapImmersiveFullscreen } from '../components/minskog/hooks/useMapImmersiveFullscreen';

// Sidebar widths: minimized  52px, expanded w-64 = 256px
const SIDEBAR_WIDTH_MINIMIZED = 52;
const SIDEBAR_WIDTH_EXPANDED = 256;

const ContentViewContainer = styled.div`
    @media (min-width:992px) {
        border-radius: var(--border-radius-rounded-4xl, 32px);
        border: 1px solid rgba(230, 230, 230, 0.50)!important;
        box-shadow: var(--shadow-xs-1-offset-x, 0) var(--shadow-xs-1-offset-y, 1px) var(--shadow-xs-1-blur-radius, 2px) var(--shadow-xs-1-spread-radius, 0) var(--shadow-xs-1-color, rgba(0, 0, 0, 0.02)), var(--shadow-xs-0-offset-x, 0) var(--shadow-xs-0-offset-y, 7px) var(--shadow-xs-0-blur-radius, 15px) var(--shadow-xs-0-spread-radius, 0) var(--shadow-xs-0-color, rgba(0, 0, 0, 0.03));
}
`

const ContentView = styled.div`
    // Replace the bootstrap part with this in future when we change to tailwind (h-[calc(100%-76px)] md:h-full)
    width: 100%;
    height: calc(100% - 76px);

    @media (min-width:768px) {
        height: 100%;
    }

    @media (min-width:992px) {
        width: ${props =>
            props.$mapImmersive
                ? '100%'
                : `calc(100% - ${props.$sidebarMinimized ? SIDEBAR_WIDTH_MINIMIZED : SIDEBAR_WIDTH_EXPANDED}px)`};
    }
`

function MinSkogContent() {
    const kartaRef = useRef();
    const aragonRef = useRef();
    const { userData, setUserData, kyc, setKyc } = useUserDataStore()
    const { props, setProps, setOneProp, activeProps } = usePropsDataStore();
    const { isDemo } = useDemoMinskogStore();
    
    const viewOptions = ['karta', 'overblick', 'annonser', 'pricing', 'virkespriser', 'settings', 'marknadsinformation', 'sell-timber']
    const urlSearchParams = new URLSearchParams(window.location.search);

    const { view, setView } = useNavigationStore();
    const [visaValda, setVisaValda] = useState(false);
    const [arbonicsDialogVisible, setArbonicsDialogVisible] = useState(false);
    const [isReady, setIsReady] = useState(false)
    
    const [demoInfoModal, setDemoInfoModal] = useState(isDemo)
    

    const { openCheckout, stepCount } = useOpenSubscriptionCheckout();
    const { openCheckout: openDroneCheckout, stepCount: droneStepCount } = useOpenDroneCheckout();

    // Main Nav
    const [openNavSheet, setOpenNavSheet] = useState(false)
    const [sidebarMinimized, setSidebarMinimized] = useState(false)

    const { mapImmersive, toggleMapImmersive } = useMapImmersiveFullscreen(view?.comp);
    const isMapImmersive = mapImmersive && view?.comp === 'karta';

    const showKYC = kyc?.hasDismissedKyc === false && kyc.hasCompletedKyc === false;

    // const numberOfDroneSteps = Object.keys(DroneSteps).length;
    const { fetchPropData, checkPropStatus } = usePropertyFetcher();

    const handleKYCComplete = async (formData) => {
        const selectedRefs = (formData.selectedPropertyRefs || []).map(String);
        const fromSearch = formData.selectedPropertiesFromSearch || [];
        const currentProps = usePropsDataStore.getState().props;
        const existingRefs = new Set(currentProps.map(p => p.ref?.toString()));

        for (const prop of fromSearch) {
            const ref = (prop.registerenhet || prop.ref)?.toString();
            if (!ref || existingRefs.has(ref)) continue;

            try {
                const getPropResponse = await getProp(prop.registerenhet || prop.ref);

                const createdProp = await generateProp({
                    geometry: getPropResponse.data.geojson.geometry,
                    prop: {
                        ...prop,
                        beteckning: prop.beteckning ?? prop.designation ?? '',
                    },
                });

                if(createdProp.data.status == 'set_visible' || createdProp.data.status == 'running') {
                    const newProp = {
                        ...createdProp.data.data,
                        checked: selectedRefs.includes(ref),
                    };

                    setOneProp(newProp);
                    checkPropStatus(setOneProp, newProp);
                }
            } catch (error) {
                console.error('Failed to create property from KYC', ref, error);
            }
        }

        currentProps.forEach(p => {
            const ref = p.ref?.toString();
            const isSelected = ref && selectedRefs.includes(ref);
            if (isSelected) {
                setOneProp({
                    ...p,
                    checked: true,
                });
            }
        });
    };

    useEffect(() => {

        const initializeData = async () => {
            // Fresh read each run (redirect lands with view=settings; avoid stale params / Strict Mode)
            const urlSearchParams = new URLSearchParams(window.location.search);

            const clearParam = (param, state = null) => {
                const url = new URL(window.location.href);
                url.searchParams.delete(param);
                history.replaceState(state, '', url.toString());
            }

            let propsToActivate = []

            // Handle URL parameters
            if(urlSearchParams) {
                if(urlSearchParams.get("drone")) {
                    openDroneCheckout();
                    clearParam('drone')
                }

                if (urlSearchParams.get("copture-thank-you")) {
                    openDroneCheckout({ step: droneStepCount });
                    clearParam('copture-thank-you')
                }

                if (urlSearchParams.get("subscription-checkout")) {
                    openCheckout();
                    clearParam('subscription-checkout')
                }

                if (urlSearchParams.get("subscription-thank-you")) {
                    openCheckout({ step: stepCount });
                    clearParam('subscription-thank-you')
                }

                if (urlSearchParams.get('view')) {
                    const v = urlSearchParams.get('view');
                    const sellAd = urlSearchParams.get('sell-timber-ad');
                    let view =
                        viewOptions.includes(v) ? { comp: v } : { comp: 'karta' };
                    if (v === 'sell-timber' && sellAd) {
                        const id = parseInt(sellAd, 10);
                        if (!Number.isNaN(id)) {
                            view = { comp: 'sell-timber', sellTimberAdId: id };
                        }
                    }
                    if (v === 'settings') {
                        const settingsTab = urlSearchParams.get('settings_tab');
                        if (settingsTab) {
                            view = { ...view, settingsTab };
                        }
                    }
                    const url = new URL(window.location.href);
                    url.searchParams.delete('view');
                    url.searchParams.delete('sell-timber-ad');
                    history.replaceState(view, '', url.toString());
                    setView(view);
                } else if (urlSearchParams.get('sell-timber-ad')) {
                    const id = parseInt(urlSearchParams.get('sell-timber-ad'), 10);
                    const url = new URL(window.location.href);
                    url.searchParams.delete('sell-timber-ad');
                    if (!Number.isNaN(id)) {
                        const nextView = { comp: 'sell-timber', sellTimberAdId: id };
                        history.replaceState(nextView, '', url.toString());
                        setView(nextView);
                    } else {
                        history.replaceState(null, '', url.toString());
                    }
                }

                if (urlSearchParams.get('carbon-credit-flow')) {
                    setArbonicsDialogVisible(true)
                    clearParam('carbon-credit-flow')
                }

                if (urlSearchParams.get("ref")) {
                    propsToActivate.push(urlSearchParams.get("ref"))
                    const url = new URL(window.location.href);
                    url.searchParams.delete('ref');
                    history.replaceState(null, '', url.toString());
                }
            }

            let CookieProps = Cookies.get('activeProps')
            if (CookieProps && CookieProps != '' && propsToActivate.length < 1) {
                CookieProps.split(',').map(c => propsToActivate.push(c))
            }

            // Get fresh server data
            const serverProps = Window.react_data?.owned_props || [];

            // Get persisted selections from store
            const persistedSelections = usePropsDataStore.getState().props;

            // Create a map of persisted selections by ref
            const selectionsMap = new Map();
            persistedSelections.forEach(p => {
                if (p.ref) selectionsMap.set(p.ref, { checked: p.checked, active: p.active });
            });

            // Start with server data, apply persisted selections
            let propsToUse = serverProps.map(serverProp => {
                const selection = selectionsMap.get(serverProp.ref);
                return {
                    ...serverProp,
                    checked: selection?.checked ?? false,
                    active: selection?.active ?? false,
                };
            });

            //demo mode, activate all on account, nothing else
            if(isDemo){
                propsToActivate = []
                Window.react_data?.owned_props.forEach((p) => propsToActivate.push(p.ref))
            }

            // Apply URL/cookie-based selections
            propsToUse = propsToUse.map(p => {
                const preSelected = propsToActivate.includes(p.ref.toString());
                return {
                    ...p,
                    checked: preSelected || p.checked,
                    active: preSelected || p.active,
                };
            });

            // Initialize store with merged data
            setProps(propsToUse);

            setIsReady(true)

            setTimeout(async () => {
                const finalProps = usePropsDataStore.getState().props; // Get latest from store
                if (finalProps.length > 10) {
                    await Promise.all(
                        finalProps.filter(p => p.active && p.status === 'data' && !p.data).map(async p => {
                            try {
                                await fetchPropData(setOneProp, p)
                            } catch (error) {
                                console.error(`Error fetching data for ${p.designation}:`, error)
                            }
                        })
                    )
                } else {
                    await Promise.all(
                        finalProps.filter(p => p.status === 'data' && !p.data).map(async p => {
                            try {
                                await fetchPropData(setOneProp, p)
                            } catch (error) {
                                console.error(`Error fetching data for ${p.designation}:`, error)
                            }
                        })
                    )
                }
            }, 200)

            // Poperties that are still being generated, keep checking for their status
            const runningProps = usePropsDataStore.getState().props.filter(p => p.status == 'running');
            runningProps.map(async p => checkPropStatus(setOneProp, p))
            if(!isDemo){
                const userAdDataResp = await fetchUserAdData()
                if (userAdDataResp.ok) {
                    setUserData(userAdDataResp.data)
                } else {
                    setUserData(false)
                }
            }
        };
        if(!isDemo){
            getKyc()
        }

        // Call the async function
        initializeData();

        // Add event listener (synchronous part)
        window.addEventListener('popstate', () => handleHistory());

        // Return cleanup function
        return () => {
            window.removeEventListener('popstate', () => handleHistory());
        };
    }, [])

    const getKyc = async () => {
        if (Cookies.get('kyc_dismissed_temp') === 'true') {
            setKyc({ hasDismissedKyc: true, hasCompletedKyc: false });
            return;
        }
        const response = await getKycPreferences();
        if (response.ok) {
            setKyc(response.data);
        } else {
            console.error('Failed to fetch KYC preferences');
        }
    };

    const handleHistory = () => {
        const newView = history.state ? history.state : { comp: 'overblick' }
        setView(newView)

        if (history.state) {
            if (history.state.active) {
                const newActiveProps = props.map(p => history.state.active.includes(p.ref) ? { ...p, active: true } : { ...p, active: false })
                setProps(newActiveProps)
                setVisaValda(true)
            }

            if (history.state.comp == 'karta') {
                kartaRef.current.handleHistory(history.state.section)
            }
        }
    }

    const {
        updateModalOpen,
        setUpdateModalOpen,
        setHasDismissedUpdateModal,
        displayProps,
        actionStatus,
        regenerateProperty,
        refuseSingleProp,
        getOldVersionDate,
    } = useUpdatePropsModal({
        props,
        isReady,
        setOneProp,
    })

    
    const tempProfileAdListingsLoading = () => {
        return <div className='container'>
            <div className='flex flex-col h-screen justify-center items-center'>
                <div className="w-10 h-10 border-4 border-current border-t-transparent rounded-full animate-spin" role="status" />
                <p className='mt-4'>Vi laddar in din data...</p>
            </div>

        </div>
    }
    
    const hasActiveProps = activeProps.some(p => p.active);
    const isViewRequiringProps = ['virkespriser', 'overblick', 'karta'].includes(view?.comp);
    const showNoActivePropsView = isReady && !hasActiveProps && isViewRequiringProps;
    const showViewContent = !showNoActivePropsView;

    return (
        <PlusBlockerDialogProvider>
            {isDemo && <DemoBlockDialog />}
            <div className='w-full overflow-hidden p-0 flex flex-col-reverse lg:flex-row' style={{ height: '100dvh' }}>
                {/* <MainNav /> */}
                <div style={isMapImmersive ? { display: 'none' } : { display: 'contents' }}>
                    <MainNavigation openNavSheet={openNavSheet} setOpenNavSheet={setOpenNavSheet} isMinimized={sidebarMinimized} onMinimizedChange={setSidebarMinimized} />
                </div>
                
                <div className="flex grow flex-col" style={{ minHeight: 0, backgroundColor: '#FBFBFB' }}>
                    <div className="flex grow flex-row overflow-hidden" style={{ minHeight: 0, minWidth: 0 }}>
                        <div className="flex grow flex-col" style={{ minHeight: 0, minWidth: 0 }}>
                            <div style={isMapImmersive ? { display: 'none' } : { display: 'contents' }}>
                                <MinskogToolbar
                                    onOpenMobileMenu={() => setOpenNavSheet(true)} 
                                    onTriggerKYC={() => setKyc({ hasDismissedKyc: false, hasCompletedKyc: false })} 
                                />
                            </div>
                            
                            <div className="sticky" style={{ zIndex: 1039, height: 0, overflow: 'hidden' }}>
                                <Toaster position="top-right" />
                            </div>
                            <ContentViewContainer className='flex grow overflow-auto' style={{ minHeight: 0 }}>
                                <ContentView id='mainContainer' className="flex-1 relative overflow-auto bg-cloud-50 p-0 m-0" $sidebarMinimized={sidebarMinimized} $mapImmersive={isMapImmersive}>
                                    {isDemo && <>
                                        <div className={`${view?.comp == 'karta' ? 'absolute' : 'sticky'} top-0 w-full max-w-[1240px] z-[1010] px-4 md:px-8 py-3 gap-2 mx-auto`}>
                                            <div className='flex justify-between items-center top-0 bg-[#F5F5F5] border-solid border-1 border-[#E6E6E6] rounded-[16px] w-full shadow-xl px-4 py-3'>
                                                <div className='flex flex-col'>
                                                    <Text variant="text-sm/leading-normal/medium">Vill du se din skog?</Text>
                                                    <Text variant="text-xs/leading-normal/normal">Du utforskar just nu en exempelfastighet.</Text>
                                                </div>

                                                <Button variant="primary" size="small" className="text-[#0F0F0F] bg-[#D5EE64] hover:bg-[#C1D75B]" onClick={() => {window.location="/min-skog/"}} aria-label="Se din skog">Se din skog</Button>
                                            </div>
                                        </div>
                                    </>}

                                    {showNoActivePropsView && <NoActivePropsView />}
                                    {showViewContent && view?.comp == 'karta' && isReady && <Karta ref={kartaRef} sidebarMinimized={sidebarMinimized} mapImmersive={isMapImmersive} onToggleMapImmersive={toggleMapImmersive} />}
                                    {showViewContent && view?.comp == 'overblick' && isReady && <Overblick />}
                                    {showViewContent && view?.comp == 'virkespriser' && isReady && <WoodpricesProvider><Woodprices /></WoodpricesProvider>}
                                    {showViewContent && view?.comp == 'overvakning' && isReady && <Aragon ref={aragonRef} />}
                                    {showViewContent && view?.comp == 'pricing' && isReady && <PricingPageNew />}
                                    {showViewContent && view?.comp == 'annonser' && (Object.keys(userData).length > 0 ? <ProfileAdListings data={userData} /> : tempProfileAdListingsLoading())}
                                    {showViewContent && view?.comp == 'settings' && (
                                        <UserSettings settingsTabIntent={view?.settingsTab} />
                                    )}
                                    {showViewContent && view?.comp == 'book-advising' && <HSBoookAdvising />}
                                    {showViewContent && view?.comp == 'marknadsinformation' && <MarketInformation />}
                                    {showViewContent && view?.comp == 'sell-timber' && (
                                        <SellTimber initialAdId={view?.sellTimberAdId ?? null} />
                                    )}
                                </ContentView>
                            </ContentViewContainer>
                        </div>

                        <SectionDetails />
                    </div>
                </div>
            </div>

            <>
                {showKYC && (
                    <KYCModal
                        properties={Window.react_data?.owned_props || []}
                        onComplete={handleKYCComplete}
                    />
                )}
                <UpdatePropsModal
                    isOpen={updateModalOpen}
                    displayProps={displayProps}
                    actionStatus={actionStatus}
                    onRegenerateProp={regenerateProperty}
                    onRefuseProp={refuseSingleProp}
                    onClose={() => {
                        setHasDismissedUpdateModal(true)
                        setUpdateModalOpen(false)
                    }}
                    getOldVersionDate={getOldVersionDate}
                />

            <Dialog isOpen={demoInfoModal} onClose={() => {setDemoInfoModal(false)}} borderLess>
                <Dialog.Header>
                    <Text variant="text-lg/leading-normal/medium">Välkommen till vår exempelfastighet</Text>
                </Dialog.Header>
                <Dialog.Content>
                    <Text variant="text-sm/leading-normal/normal">
                    Här kan du utforska alla delar av plattformen och se hur den fungerar i praktiken. <br/>
                    Observera att vissa funktioner är begränsade i exemplet. För full tillgång till samtliga funktioner behöver du Plus.
                    </Text>
                </Dialog.Content>
                <Dialog.Footer>
                    <Button variant="primary" onClick={() => {setDemoInfoModal(false)}}>Gå vidare</Button>
                </Dialog.Footer>
            </Dialog>

            </>

            <ArbonicsDialog visible={arbonicsDialogVisible} hide={() => { setArbonicsDialogVisible(false) }} />
        </PlusBlockerDialogProvider>
    );
}

export default function MinSkog() {

    return (
        <DFRProvider>
            <DroneCheckoutWrapper>
                <MinSkogContent />
            </DroneCheckoutWrapper>
        </DFRProvider>
    );
}